import React, { useEffect, useState } from "react";
import { Box, Button, Heading, Spinner, Stack, VStack } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import PodcastCard from "../../components/PodcastCard";
import { buildApiUrl, createHeaders } from "../../services/apiClient";

export default function LatestPodcastsCard({
  cardBg,
  cardTitle,
  cardMuted,
  themeId,
  regionId,
  limit = 3,
}) {
  const [episodes, setEpisodes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const params = new URLSearchParams({ limit: String(limit) });
        if (themeId) params.set("themeId", themeId);
        if (regionId) params.set("regionId", regionId);
        const res = await fetch(
          buildApiUrl(`/podcast/all-episodes?${params.toString()}`),
          { headers: createHeaders() },
        );
        if (!res.ok) return;
        const data = await res.json();
        setEpisodes(data.episodes || []);
      } catch {
        /* silent */
      } finally {
        setLoading(false);
      }
    })();
  }, [themeId, regionId, limit]);

  if (!loading && episodes.length === 0) return null;

  return (
    <Box
      bg={cardBg}
      borderRadius="md"
      overflow="hidden"
      boxShadow="md"
      p={4}
    >
      <VStack spacing={3} align="stretch">
        <Heading size="sm" color={cardTitle}>
          New Podcasts
        </Heading>

        {loading && <Spinner size="sm" />}

        <Stack spacing={2}>
          {episodes.map((ep) => (
            <PodcastCard key={ep.id} episode={ep} />
          ))}
        </Stack>

        <Button
          as={RouterLink}
          to="/podcasts"
          size="xs"
          variant="link"
          color="gwbi.300"
          textDecoration="underline"
        >
          View all podcasts
        </Button>
      </VStack>
    </Box>
  );
}
